// Geography code helpers.
//
// Destination codes are length-encoded - the length determines the level, and
// codes are prefix-encoded so a descendant's code starts with its ancestor's:
//   2 chars  -> country (e.g. "ES")
//   4 chars  -> region  (e.g. "ESCN")
//   6 chars  -> resort  (e.g. "CYCYAN")
//   numeric  -> hotel id (e.g. "254")

// Hotels/tours have numeric codes; geography codes are alphabetic.
export const isHotelCode = (code) => /^\d+$/.test(code);

// The hierarchy level a code represents, or null if it doesn't fit the scheme.
export const levelForCode = (code) => {
    if (!code) return null;
    if (isHotelCode(code)) return "hotel";
    if (code.length === 2) return "country";
    if (code.length === 4) return "region";
    if (code.length === 6) return "resort";
    return null;
};
